import { observable } from 'mobx';
import Model from './Model';
import Version from "./Version";


class WeekStore extends Model {
  static basePath = '/api/week-stores';
  static verboseName = 'WeekStore';

  @observable year;
  @observable week;
  @observable technology_family;

  toString() {
    if (this.isLoaded) {
      const fakeVersion = new Version({ technology_family: this.technology_family });
      return `${this.year} W${this.week} [${fakeVersion.getValueLabel('technology_family')}]`;
    }
    return super.toString();
  }
}


export default WeekStore;
